import React, { useState } from "react";
import "./ColorSamples.css";
import room1 from "../assets/room1.png";
import room2 from "../assets/room2.png";
import room3 from "../assets/room3.png";
import room4 from "../assets/room4.png";
import room5 from "../assets/room5.png";
import room6 from "../assets/room6.png";
import room7 from "../assets/room7.png";

const roomColors = [
  [
    {
      name: "Tranquil Tide",
      hex: "#7ABBBF",
      pantone: "4157 C",
      rgb: "(122,187,191,1))",
    },
    {
      name: "Misty Sage",
      hex: "#8D9389",
      pantone: "1795 C",
      rgb: "(141,147,137,1)",
    },
    {
      name: "Maple Spice",
      hex: "#B6632E",
      pantone: "4164 C",
      rgb: "(182,99,46,1)",
    },
    {
      name: "Honeyed",
      hex: "#916C26",
      pantone: "2011 C",
      rgb: "(145,108,38,1)",
    },
    {
      name: "Citrus Glow",
      hex: "#F99C25",
      pantone: "158 C",
      rgb: "(249,156,37,1)",
    },
  ],
  [
    {
      name: "Dusty Olive",
      hex: "#AEAB83",
      pantone: "4157 C",
      rgb: "(174,171,131,1)",
    },
    {
      name: "Desert Dune",
      hex: "#DEB982",
      pantone: "1795 C",
      rgb: "(222,185,130,1)",
    },
    {
      name: "Honey Gold",
      hex: "#EEB244",
      pantone: "4164 C",
      rgb: "(238,178,68,1)",
    },
    {
      name: "Rustic Amber",
      hex: "#BE8245",
      pantone: "2011 C",
      rgb: "(190,130,69,1)",
    },
    {
      name: "Clay Rose",
      hex: "#C77B63",
      pantone: "158 C",
      rgb: "(199,123,99,1)",
    },
  ],
  [
    {
      name: "Sky Cyan",
      hex: "#2DCDE0",
      pantone: "4157 C",
      rgb: "(45,205,224,1)",
    },
    {
      name: "Cool Lagoon",
      hex: "#80B7BC",
      pantone: "1795 C",
      rgb: "(128,183,188,1)",
    },
    {
      name: "Peony Pink",
      hex: "#F87E97",
      pantone: "4164 C",
      rgb: "(248,126,151,1)",
    },
    {
      name: "Ashen Taupe",
      hex: "#BBACA9",
      pantone: "2011 C",
      rgb: "(187,172,169,1)",
    },
    {
      name: "Sunset Gold",
      hex: "#EB8C09",
      pantone: "158 C",
      rgb: "(235,140,9,1)",
    },
  ],
  [
    {
      name: "Muted Petal",
      hex: "#C6A8A6",
      pantone: "4157 C",
      rgb: "(198,168,166,1)",
    },
    {
      name: "Petal Veil",
      hex: "#EFD6D1",
      pantone: "1795 C",
      rgb: "(239,214,209,1)",
    },
    {
      name: "Golden Oat",
      hex: "#CCAD91",
      pantone: "4164 C",
      rgb: "(204,173,145,1)",
    },
    {
      name: "Blush Flame",
      hex: "#E57574",
      pantone: "2011 C",
      rgb: "(229,117,116,1)",
    },
    {
      name: "Rustwood",
      hex: "#743930",
      pantone: "158 C",
      rgb: "(116,57,48,1)",
    },
  ],
  [
    {
      name: "Ocean Fog",
      hex: "#9AAAA9",
      pantone: "4157 C",
      rgb: "(154,170,169,1)",
    },
    {
      name: "Steel Mist",
      hex: "#7F919D",
      pantone: "1795 C",
      rgb: "(127,145,157,1)",
    },
    {
      name: "Olive Gold",
      hex: "#C2A94D",
      pantone: "4164 C",
      rgb: "(194,169,77,1)",
    },
    {
      name: "Blush Sand",
      hex: "#E6C4BA",
      pantone: "2011 C",
      rgb: "(230,196,186,1)",
    },
    {
      name: "Sunlit Pearl",
      hex: "#F9DBB9",
      pantone: "158 C",
      rgb: "(249,219,185,1)",
    },
  ],
  [
    {
      name: "Ashen Dune",
      hex: "#BCB9B2",
      pantone: "4157 C",
      rgb: "(188,185,178,1)",
    },
    {
      name: "Aqua Drift",
      hex: "#6ECECA",
      pantone: "1795 C",
      rgb: "(110,206,202,1)",
    },
    {
      name: "Sunburst",
      hex: "#ECD204",
      pantone: "4164 C",
      rgb: "(236,210,4,1)",
    },
    {
      name: "Citrus Amber",
      hex: "#FFC16A",
      pantone: "2011 C",
      rgb: "(255,193,106,1)",
    },
    {
      name: "Vintage Ember",
      hex: "#B27F7B",
      pantone: "158 C",
      rgb: "(178,127,123,1)",
    },
  ],
  [
    {
      name: "Teal Abyss",
      hex: "#097487",
      pantone: "4157 C",
      rgb: "(9,116,135,1)",
    },
    {
      name: "Garnet Rose",
      hex: "#97123D",
      pantone: "1795 C",
      rgb: "(151,18,61,1)",
    },
    {
      name: "Cedar Rust",
      hex: "#9E5449",
      pantone: "4164 C",
      rgb: "(158,84,73,1)",
    },
    {
      name: "Solar Gold",
      hex: "#F5BB19",
      pantone: "2011 C",
      rgb: "(245,187,25,1)",
    },
    {
      name: "Candy Rose",
      hex: "#F96197",
      pantone: "158 C",
      rgb: "(249,97,151,1)",
    },
  ],
];

const previewImages = [room1, room2, room3, room4, room5, room6, room7];

export default function ColorSamples() {
  const [selectedRoom, setSelectedRoom] = useState(0);
  const [selectedColor, setSelectedColor] = useState(roomColors[0][0]);

  return (
    <section className="color-section">
      <h2>Color samples</h2>
      <p className="subtitle">Explore our full spectrum of timeless colors.</p>

      <div className="color-layout">
        {/* LEFT SIDE - SWATCHES (dynamic per room) */}
        <div className="swatch-row">
          {roomColors[selectedRoom].map((color, i) => (
            <div
              key={i}
              className={`color-swatch ${
                selectedColor.name === color.name ? "active" : ""
              }`}
              style={{ backgroundColor: color.hex }}
              // onClick={() => setSelectedColor(color)}
            >
              <div className="color-details">
                <h4>{color.name}</h4>
                <p>Pantone: {color.pantone}</p>
                <p>HEX Color: {color.hex}</p>
                <p>RGB: {color.rgb}</p>
              </div>
              <div className="brand-logo">
                <img src="/assets/gl.png" alt="Brand" className="brand-img" />
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT SIDE - IMAGE PREVIEW */}
        <div className="preview-panel">
          <div className="main-preview">
            <img src={previewImages[selectedRoom]} alt="Room Preview" />
            <div
              className="color-overlay"
              // style={{ backgroundColor: selectedColor.hex }}
            ></div>
          </div>

          {/* THUMBNAILS */}
          <div className="thumbnail-row">
            {previewImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Preview ${index}`}
                className={`thumb ${selectedRoom === index ? "active" : ""}`}
                onClick={() => {
                  setSelectedRoom(index);
                  setSelectedColor(roomColors[index][0]); 
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
